<template>
  <div class="flex flex-wrap justify-center w-full gap-4 sm:w-auto">
    <!-- Email Button -->
    <button
      @click="sendEmail"
      class="flex items-center w-full px-6 py-4 font-semibold text-white transition-all duration-300 transform bg-gray-900 rounded-md cursor-pointer sm:w-auto hover:bg-gray-800 dark:bg-zinc-700 dark:text-zinc-100 dark:hover:bg-zinc-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-600 dark:focus:ring-zinc-500 hover:scale-105"
    >
      <Icon
        name="material-symbols:mail"
        class="inline-block mr-4 text-2xl transition-transform duration-300 group-hover:rotate-12"
      />
      {{ $t("buttons.sendMeAnEmail") }}
    </button>

    <!-- WhatsApp Button -->
    <a
      :href="whatsappLink + encodedMessage"
      target="_blank"
      class="flex items-center w-full px-6 py-4 font-semibold text-white transition-all duration-300 transform bg-green-600 rounded-md cursor-pointer animate-pulse sm:w-auto hover:bg-green-500 dark:bg-green-700 dark:text-zinc-100 dark:hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-600 dark:focus:ring-green-500 hover:scale-105"
    >
      <Icon
        name="logos:whatsapp-icon"
        class="inline-block mr-4 text-3xl transition-transform duration-300 group-hover:rotate-12"
      />
      {{ $t("buttons.contactUsOnWhatsApp") }}
    </a>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

const i18n = useI18n();

const sendEmail = () => {
  // Add your email logic here, like opening a mail client or navigating to a contact page
  window.location.href = "mailto:studio@highfield.pt";
};

// Define your WhatsApp link constant and encoded message dynamically
const whatsappLink = "https://wa.me//351967998541?text=";

const encodedMessage = ref(
  encodeURIComponent(i18n.t("messages.whatsappMessage")),
);
</script>
